import React from 'react';
import { SvgIcon } from '@material-ui/core';

const FileIcon = props => {
  return (
    <SvgIcon {...props}>
      <path d="M10.674 6.5V0h-9.53A1.143 1.143 0 000 1.148v22.191a1.143 1.143 0 001.144 1.148h16.011a1.143 1.143 0 001.145-1.148V7.652h-6.482A1.149 1.149 0 0110.674 6.5zm7.291-1.483L13.3.335A1.141 1.141 0 0012.49 0h-.29v6.122h6.1V5.83a1.146 1.146 0 00-.335-.808z" />
    </SvgIcon>
  );
};

export default FileIcon;
